import { PageHeader, cn } from '@agos/ui'
import { T, tt, useAuth } from '@agos/shared'
import { Smartphone } from 'lucide-react'

import { PushMessageEditor } from '../settings-notifications/SettingsNotificationsPage'
import { mayWrite } from '../write-access'

/**
 * `/settings-pushup` - the push wording, as its own tab - §9.298.
 *
 * **The owner filed it here**: *"Text push oznámení. Move it to next to E-Mail as «Pushup»"*. It sat
 * at the bottom of *Notifikácie & kanály*, which answers *which channel carries which event* - a
 * different question from *what does the message say*. `SettingsSmsPage` and `SettingsEmailPage` own
 * their channels' wording; this is the third channel filed the same way.
 *
 * A thin page over the editor that already existed, which keeps `CHANNEL_ICON` and the placeholder
 * helpers where the event rows still use them.
 */
export function SettingsPushupPage() {
  const { user, hasPermission } = useAuth()
  /* §9.758, BACKEND.md §10A.413 - `PUT /notifications/push-messages/{key}` asks `settings_notifications_edit`. The
     section was spelled `settings_notifications`, which was in neither list and so answered *main admin only*
     whatever the person held - the message below promised a right that could not open it. */
  const writable = mayWrite('pushup', user?.systemRole, hasPermission)

  return (
    <div className={cn('space-y-4')}>
      <PageHeader
        title={tt('Pushup')}
        description={tt('Texty push oznámení, ktoré zákazník uvidí na telefóne')}
        icon={<Smartphone className="w-5 h-5" />}
      />
      {!writable && (
        <p className="text-xs text-muted-foreground">
          <T>Na úpravu textov potrebujete oprávnenie na nastavenia notifikácií.</T>
        </p>
      )}
      <PushMessageEditor writable={writable} />
    </div>
  )
}
